import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const GcpCloudSqlComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "IAM management",
    description: "Allows P0 to manage access to GCP CloudSQL instances.",
    type: "string",
    maturity: "preview",
    schema: {
      projectId: Element({
        label: "GCP project ID",
        description: "The GCP Project in which this VPC is provisioned",
        type: "dynamic",
        step: "new",
      }),
      connectorSubnetwork: Element({
        label: "Subnetwork",
        description:
          "The name of the subnetwork to which the Cloud Run connector should have direct VPC access to",
        type: "string",
        step: "new",
      }),
      connectorServiceName: Element({
        label: "GCP Cloud Run service name",
        description: "",
        type: "generated",
      }),
      connectorServiceUri: Element({
        label: "GCP Cloud Run service URI",
        description:
          "The invocation URL of the connector's Cloud Run service, resolved once at install time.",
        type: "generated",
      }),
      connectorServiceAccount: Element({
        label: "GCP Cloud Run service account",
        description: "The GCP service account that the connector is running as",
        type: "generated",
      }),
      connectorRegion: Element({
        label: "Region",
        description:
          "The GCP region in which this instance is provisioned. defaults to us-west1",
        type: "hidden",
        step: "new",
      }),
    },
  }),
});
